import React, { useEffect, useState } from "react";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import { useDispatch, useSelector } from "react-redux";
import {
  DateInput,
  SelectInput,
  TextAreaInput,
  TextInput,
} from "../../../../components/common/ui/Inputs";
import { eventsActions } from "../../../../_store/events.slice";
import { useLocation } from "react-router-dom";
import Table from "../../../../components/common/table/Table";
import Button from "../../../../components/common/ui/Button";
import calenderSchema from "../../../../validation/Admin/CalenderSchema";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import deleteIcon from "../../../../assets/svg/delete-icon.svg";
import CustomLoader from "../../../../components/common/ui/Loader";
import { Popup } from "../../../../components/common/ui/NotificationModal/Popup";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import MultiSelectDropdown from "../../../../components/common/ui/Inputs/MultiSelectDropdown";
import { history } from "../../../../_helpers";
import Swal from "sweetalert2";
import CollapsibleTable from "../../../../components/common/table/CollapsiveTable";

function CommitteeEventPage() {
  const dispatch = useDispatch();
  const {
    eventType,
    locationType,
    numberSet,
    monthFrequencySet,
    periodSet,
    daySet,
  } = useSelector((x) => x?.dropDown);

  const {
    eventForm,
    getEventListResponse,
    getRecurrenceEventListResponse,
    loading,
  } = useSelector((x) => x?.events);

  const { ActiveStatus } = useSelector((x) => x?.dropDown);

  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [isCreateMode, setisCreateMode] = useState(false);
  const [editRow, setEditRow] = useState({});
  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`,
  );
  const [recurrenceApiParams, setRecurrenceApiParams] = useState(
    `?page=${1}&limit=${10}`,
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);

  const [recurrencePageNo, setRecurrencePageNo] = useState(1);
  const [recurrencerowCountPerPage, setRecurrenceRowCountPerPage] =
    useState(10);
  const [Filter, setFilter] = useState({
    title: "",
    startDateTime: "",
    endDateTime: "",
    status: true,
  });
  const [expandedRows, setExpandedRows] = useState({});

  // const eventForm = eventForm;
  const location = useLocation();
  const committee = location?.state?.committee;
  const totalCount = getEventListResponse?.data?.totalItems || 0;
  const recurrenceTotalCount =
    getRecurrenceEventListResponse?.data?.totalItems || 0;
  // const [selectedRowEvents, setSelectedRowEvents] = useState([]);

  useEffect(() => {
    const resetHandler = () => {
      setIsEditMode(false);
      setisCreateMode(false);
    };

    window.addEventListener("resetCalendarPage", resetHandler);
    return () => {
      window.removeEventListener("resetCalendarPage", resetHandler);
    };
  }, []);

  const columns = [
    {
      // width: "200px",
      name: "Title",
      key: "memberId",
      selector: (row) => row.title,
      sortable: true,
    },
    // {
    //   name: "Start",
    //   key: "start",
    //   selector: (row) => {
    //     return new Date(row.start).toLocaleString("en-IN", {
    //       year: "numeric",
    //       month: "2-digit",
    //       day: "2-digit",
    //       hour: "2-digit",
    //       minute: "2-digit",
    //       hour12: true,
    //     });
    //   },

    //   sortable: true,
    // },
    {
      name: "Start",
      key: "start",
      // selector: (row) => {
      //   return new Date(row.start)
      //     .toLocaleString("en-IN", {
      //       year: "numeric",
      //       month: "2-digit",
      //       day: "2-digit",
      //       hour: "2-digit",
      //       minute: "2-digit",
      //       hour12: true,
      //     })
      //     .replace(/am|pm/, (match) => match.toUpperCase());
      // },
      selector: (row) => {
        const formatted = new Date(row.start).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // or "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },
      sortable: true,
    },

    {
      // width: "200px",
      name: "End",
      key: "end",
      // selector: (row) => {
      //   return new Date(row.end)
      //     .toLocaleString("en-IN", {
      //       year: "numeric",
      //       month: "2-digit",
      //       day: "2-digit",
      //       hour: "2-digit",
      //       minute: "2-digit",
      //       hour12: true,
      //     })
      //     .replace(/am|pm/, (match) => match.toUpperCase());
      // },
      selector: (row) => {
        const formatted = new Date(row?.end).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // or "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },
      sortable: true,
    },
    {
      // width: "200px",
      name: "Committee Name",
      key: "email",
      selector: (row) => row.committee?.committeeName,
      sortable: true,
    },

    {
      // width: "200px",
      name: "Created by",
      key: "phoneNumber",
      selector: (row) =>
        row.createdBy
          ? row.createdBy?.firstName + " " + row.createdBy?.lastName
          : "-",
      sortable: true,
    },
    {
      // width: "80px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              editEvent(row);
            }}
          />
          <img
            src={deleteIcon}
            title="Delete"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleSingleEventDelete(row);
            }}
          />
          <ToggleSwitch
            name={`Status${row.memberId}`}
            id={`Status${row.memberId}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleSingleEventStatusUpdate(e, row)}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const recurrenceTableColumn = [
    {
      // width: "200px",
      name: "Title",
      key: "memberId",
      selector: (row) => row.title,
      cell: (row) => (
        <div
        // onClick={() => navigateFacilityEdit(row.FacilityID)}
        // className="Common_Link_Style"
        >
          {row.title}
        </div>
      ),
      sortable: true,
    },

    // {
    //   width: "200px",
    //   name: "Start",
    //   key: "firstName",
    //   selector: (row) => {
    //     return new Date(row.start).toLocaleString("en-IN", {
    //       year: "numeric",
    //       month: "2-digit",
    //       day: "2-digit",
    //       hour: "2-digit",
    //       minute: "2-digit",
    //       hour12: true,
    //     });
    //   },

    //   sortable: true,
    // },
    // {
    //   width: "200px",
    //   name: "End",
    //   key: "lastName",
    //   selector: (row) => {
    //     return new Date(row.end).toLocaleString("en-IN", {
    //       year: "numeric",
    //       month: "2-digit",
    //       day: "2-digit",
    //       hour: "2-digit",
    //       minute: "2-digit",
    //       hour12: true,
    //     });
    //   },
    //   sortable: true,
    // },
    {
      // width: "200px",
      name: "Committee Name",
      key: "email",
      selector: (row) => row.committee?.committeeName,
      sortable: true,
    },

    {
      // width: "200px",
      name: "Created by",
      key: "phoneNumber",
      selector: (row) =>
        row.createdBy
          ? row.createdBy?.firstName + " " + row.createdBy?.lastName
          : "-",
      sortable: true,
    },
    {
      // width: "80px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={deleteIcon}
            title="Delete"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleRecurrenceEventDelete(row);
            }}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const ChildrenColumn = [
    {
      // width: "100px",
      name: "S.No",
      key: "memberId",
      selector: (row, i) => i + 1,
      sortable: true,
    },
    {
      // width: "250px",
      name: "Title",
      key: "memberId",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      // width: "250px",
      name: "Start",
      key: "firstName",
      // selector: (row) => {
      //   return new Date(row.start)
      //     .toLocaleString("en-IN", {
      //       year: "numeric",
      //       month: "2-digit",
      //       day: "2-digit",
      //       hour: "2-digit",
      //       minute: "2-digit",
      //       hour12: true,
      //     })
      //     .replace(/am|pm/, (match) => match.toUpperCase());
      // },
      selector: (row) => {
        const formatted = new Date(row.start).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // or "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },

      sortable: true,
    },
    {
      // width: "250px",
      name: "End",
      key: "lastName",
      // selector: (row) => {
      //   return new Date(row.end)
      //     .toLocaleString("en-IN", {
      //       year: "numeric",
      //       month: "2-digit",
      //       day: "2-digit",
      //       hour: "2-digit",
      //       minute: "2-digit",
      //       hour12: true,
      //     })
      //     .replace(/am|pm/, (match) => match.toUpperCase());
      // },
      selector: (row) => {
        const formatted = new Date(row.end).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // or "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },

      sortable: true,
    },

    {
      // width: "250px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              editEvent(row);
            }}
          />
          <img
            src={deleteIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleSingleEventDelete(row);
            }}
          />
          <ToggleSwitch
            name={`Status${row.memberId}`}
            id={`Status${row.memberId}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleSingleEventStatusUpdate(e, row)}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "10",
      ...Object.fromEntries(
        Object.entries(Filter).filter(([_, v]) => v !== ""),
      ),
    }).toString();

    setApiParams(`?${query}`);
  }, [Filter]);

  useEffect(() => {
    if (!committee) return;
    const searchParams = `${apiParams}&committee=${committee?._id}`;
    dispatch(eventsActions?.getEventList(searchParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [committee]);

  useEffect(() => {
    if (!committee) return;
    //get event list for grid
    const searchParams = `${apiParams}&committee=${committee?._id}`;
    dispatch(eventsActions?.getRecurrenceEventList(searchParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [committee]);


  const editEvent = (row) => {
    setisCreateMode(false);
    setEditRow(row);
    const eventRow = { ...row };
    setIsEditMode(true);
    // setEventID(row?._id);
    eventRow["start"] = eventRow?.start ? new Date(row?.start) : "";
    eventRow["end"] = eventRow?.end ? new Date(row?.end) : "";
    eventRow["eventType"] = "single";
    dispatch(eventsActions?.updateForm(eventRow));

    Object.keys(expandedRows).forEach((key) => {
      expandedRows[key] = false;
    });
  };

  useEffect(() => {
    Swal.close();
  }, []);

  const handleSingleEventDelete = (row) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete the event?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        // setEventID(row?._id);
        dispatch(eventsActions?.deleteSingleEvent(row?._id))
          .then((result) => {
            if (result?.payload?.status === 1) {
              setIsPending(false);
              showToastNotification(result?.payload?.message, "success");
              const searchParams = `${apiParams}&committee=${committee?._id}`;
              dispatch(eventsActions?.getEventList(searchParams));
            } else {
              showToastNotification(result?.error?.message, "error");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to create member", "error");
          });
        //close accordian
        Object.keys(expandedRows).forEach((key) => {
          expandedRows[key] = false;
        });
      },
    });
  };

  const handleRecurrenceEventDelete = (row) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete the event?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        // setEventID(row?._id);
        dispatch(eventsActions?.deleteRecurrenceEvent(row?._id))
          .then((result) => {
            if (result?.payload?.status === 1) {
              setIsPending(false);
              showToastNotification(result?.payload?.message, "success");
              const searchParams = `${apiParams}&committee=${committee?._id}`;
              dispatch(eventsActions?.getEventList(searchParams));
              dispatch(eventsActions?.getRecurrenceEventList(searchParams));
            } else {
              showToastNotification(result?.error?.message, "error");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to create member", "error");
          });
      },
    });
  };

  const handleSingleEventStatusUpdate = (e, row) => {
    dispatch(eventsActions?.updateSingleEventStatus(row?._id))
      .then((result) => {
        if (result?.payload?.status === 1) {
          setIsPending(false);
          showToastNotification(result?.payload?.message, "success");
          const searchParams = `${apiParams}&committee=${committee?._id}`;
          dispatch(eventsActions?.getEventList(searchParams));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create member", "error");
      });
    //close accordian
    Object.keys(expandedRows).forEach((key) => {
      expandedRows[key] = false;
    });
  };

  const handleChange = (e, select) => {
    const form = { ...eventForm };
    if (select) {
      form[select] = e;
      if (errorMessage[select]) {
        setErrorMessage((prev) => ({ ...prev, [select]: "" }));
      }
      dispatch(eventsActions?.updateForm(form));
      return;
    }
    const { name, value } = e?.target;
    if (name === "title" && value.length > 150) {
      return;
    }
    if (errorMessage[name]) {
      setErrorMessage((prev) => ({ ...prev, [name]: "" }));
    }
    form[name] = value;
    if (name === "location") {
      form["url"] = "";
      form["address"] = "";
    }
    dispatch(eventsActions?.updateForm(form));
  };

  const handleSelectBoxChanges = (e, select) => {
    const form = { ...eventForm };
    form[select] =
      e?.value === undefined && select === "repeatEvery"
        ? 1
        : e?.value === undefined && select === "period"
          ? ""
          : e?.value;
    dispatch(eventsActions?.updateForm(form));
    return;
  };

  const handleWeekDayChanges = (e, select) => {
    const form = { ...eventForm };
    const selectedIds = e?.map((item) => item.value) || [];
    form[select] = selectedIds;
    dispatch(eventsActions?.updateForm(form));
  };

  const handleMonthDayChanges = (e, select) => {
    const form = { ...eventForm };
    const selectedIds = e?.map((item) => item.value) || [];
    form[select] = selectedIds;
    dispatch(eventsActions?.updateForm(form));
  };

  const handleAllDay = (e) => {
    const form = { ...eventForm };
    const { name, checked } = e?.target;
    form[name] = checked ? 1 : 0;

    dispatch(eventsActions?.updateForm(form));
  };

  function formatLocalDate(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);

    return (
      date?.getFullYear() +
      "-" +
      pad(date?.getMonth() + 1) +
      "-" +
      pad(date?.getDate()) +
      "T" +
      pad(date?.getHours()) +
      ":" +
      pad(date?.getMinutes()) +
      ":" +
      pad(date?.getSeconds())
    );
  }

  const handleSubmit = (e) => {
    e?.preventDefault();
    setErrorMessage({});
    setIsPending(true);
    const form = { ...eventForm };
    form["committee"] = committee?._id;
    // form["start"] = form?.start ? formatLocalDate(new Date(form["start"])) : "";
    // form["end"] = form?.end ? formatLocalDate(new Date(form["end"])) : "";

    const payload = {
      ...form,
      start: form.start ? formatLocalDate(new Date(form.start)) : "",
      end: form.end ? formatLocalDate(new Date(form.end)) : "",
    };

    //dispatch(eventsActions?.updateForm(form));
    const { error } = calenderSchema(payload);
    if (error?.details) {
      setIsPending(false);
      const errors = {};
      error.details.forEach((err) => {
        const key = err.path[0];
        if (!errors[key]) {
          errors[key] = err.message;
        }
      });
      setErrorMessage(errors);
      return;
    }

    const request = isEditMode
      ? dispatch(eventsActions?.updateEvent(payload))
      : eventForm?.eventType === "single"
        ? dispatch(eventsActions?.createEvent(payload))
        : dispatch(eventsActions?.createRecurrenceEvent(payload));
    request
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");

          const searchParams = `${apiParams}&committee=${committee?._id}`;
          dispatch(eventsActions?.getEventList(searchParams));
          dispatch(eventsActions?.getRecurrenceEventList(searchParams));

          dispatch(eventsActions?.resetForm({}));
          setisCreateMode(false);
          setIsEditMode(false);
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create member", "error");
      });
  };

  const handleReset = () => {
    const row = { ...editRow };
    row["start"] = new Date(row["start"]);
    row["end"] = new Date(row["end"]);
    setErrorMessage({});
    isEditMode
      ? dispatch(eventsActions?.updateForm(row))
      : dispatch(eventsActions?.resetForm({}));
  };

  // const isSameDay = (start, end) => {
  //   debugger;
  //   return (
  //     start &&
  //     end &&
  //     start?.getFullYear() === end?.getFullYear() &&
  //     start?.getMonth() === end?.getMonth() &&
  //     start?.getDate() === end?.getDate()
  //   );
  // };
  const isSameDay = (start, end) => {
    if (!start || !end) return false;

    const startDate = start instanceof Date ? start : new Date(start);
    const endDate = end instanceof Date ? end : new Date(end);

    return (
      startDate?.getFullYear() === endDate?.getFullYear() &&
      startDate?.getMonth() === endDate?.getMonth() &&
      startDate?.getDate() === endDate?.getDate()
    );
  };

  const handleRowPerPage = (page) => {
    let updatedParams = apiParams;
    updatedParams = updatedParams.replace(/(&limit=)\d+/, `$1${page}`);
    if (updatedParams.includes("&committee=")) {
      updatedParams = updatedParams.replace(
        /(&committee=)[^&]*/,
        `$1${committee?._id}`,
      );
    } else {
      updatedParams += `&committee=${committee?._id}`;
    }

    setApiParams(updatedParams);
    dispatch(eventsActions?.getEventList(updatedParams));
    setRowCountPerPage(page);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    debugger;
    let updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    if (updatedParams.includes("&committee=")) {
      updatedParams = updatedParams.replace(
        /(&committee=)[^&]*/,
        `$1${committee?._id}`,
      );
    } else {
      updatedParams += `&committee=${committee?._id}`;
    }
    setApiParams(updatedParams);
    dispatch(eventsActions?.getEventList(updatedParams));
    setPageNo(page);
  };

  const handleRcurrenceRowPerPage = (page) => {
    debugger;
    let updatedParams = recurrenceApiParams;
    updatedParams = updatedParams.replace(/([?&]limit=)\d+/, `$1${page}`);
    if (updatedParams.includes("&committee=")) {
      updatedParams = updatedParams.replace(
        /(&committee=)[^&]*/,
        `$1${committee?._id}`,
      );
    } else {
      updatedParams += `&committee=${committee?._id}`;
    }

    setRecurrenceApiParams(updatedParams);
    dispatch(eventsActions?.getRecurrenceEventList(updatedParams));
    setRecurrenceRowCountPerPage(page);
    setRecurrencePageNo(1);
  };

  const handleRecurrencePageChange = (page) => {
    debugger;
    let updatedParams = recurrenceApiParams.replace(
      /([?&])page=\d+/,
      `$1page=${page}`,
    );
    if (updatedParams.includes("&committee=")) {
      updatedParams = updatedParams.replace(
        /(&committee=)[^&]*/,
        `$1${committee?._id}`,
      );
    } else {
      updatedParams += `&committee=${committee?._id}`;
    }
    setRecurrenceApiParams(updatedParams);
    dispatch(eventsActions?.getRecurrenceEventList(updatedParams));
    setRecurrencePageNo(page);
  };

  // const handleRowClick = (expand, row) => {
  //   if (expand) return;
  //   dispatch(eventsActions?.getRecurrenceDetailsByID(row?._id))
  //     .then((result) => {
  //       if (result?.payload?.status === 1) {
  //         const eventList = getRecurrenceEventListResponse?.data?.events?.map(
  //           (item, index) => {
  //             if (item?._id === row?._id) {
  //               return {
  //                 ...item,
  //                 children: result?.payload?.data?.events,
  //               };
  //             }
  //             return { ...item };
  //           }
  //         );
  //         dispatch(eventsActions?.updateRecurrenceEventList(eventList));
  //         setSelectedRowEvents(eventList);
  //       } else {
  //         showToastNotification(result?.error?.message, "error");
  //       }
  //     })
  //     .catch((err) => {
  //       showToastNotification("Failed to create member", "error");
  //     });
  // };

  const handleRowClick = (expanded, row) => {
    // track expanded state per row
    setExpandedRows((prev) => ({
      ...prev,
      [row._id]: expanded, // true or false
    }));

    // only fetch API when row is opening
    if (!expanded) return;
    dispatch(eventsActions?.getRecurrenceDetailsByID(row?._id))
      .then((result) => {
        if (result?.payload?.status === 1) {
          const eventList = getRecurrenceEventListResponse?.data?.events?.map(
            (item, index) => {
              if (item?._id === row?._id) {
                return {
                  ...item,
                  children: result?.payload?.data?.events,
                };
              }
              return { ...item };
            },
          );
          dispatch(eventsActions?.updateRecurrenceEventList(eventList));
          // setSelectedRowEvents(eventList);
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create member", "error");
      });
  };

  const handleSearchChange = (e, select) => {
    debugger;
    let filtersearch = { ...Filter };

    if (select) {
      filtersearch[select] = e === null ? "" : e;
      setFilter(filtersearch);
      return;
    }
    const { name, value, type } = e?.target;
    const filterParams = { ...Filter };
    filterParams[name] =
      type === "radio" ? (value === "true" ? true : false) : value;
    setFilter(filterParams);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const searchParams = `${apiParams}&committee=${committee?._id}`;
    dispatch(eventsActions?.getEventList(searchParams));
    dispatch(eventsActions?.getRecurrenceEventList(searchParams));
  };

  const handleSearchFormReset = (e) => {
    debugger;
    e.preventDefault();
    setExpandedRows({});
    setFilter({
      title: "",
      startDateTime: "",
      endDateTime: "",
      status: true,
    });
    const searchParams = `?page=${1}&limit=${10}&status=${true}&committee=${committee?._id
      }`;
    dispatch(eventsActions?.getEventList(searchParams));
    dispatch(eventsActions?.getRecurrenceEventList(searchParams));
  };

  if (loading) return <CustomLoader />;
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="header-color">{committee?.committeeName}</h3>
        <div>
          {isEditMode === false && isCreateMode === false && (
            <Button
              className="me-2"
              label="Create"
              status="secondary"
              onClick={() => {
                setisCreateMode(true);
                setIsEditMode(false);
                dispatch(eventsActions?.resetForm({}));
              }}
            />
          )}
          <Button
            label="Back"
            status="reset"
            onClick={() => {
              setErrorMessage({});
              isEditMode === false && isCreateMode === false
                ? history?.navigate("/Admin/CommitteePage")
                : setIsEditMode(false);
              setisCreateMode(false);
            }}
          />
        </div>
      </div>
      {isEditMode === false && isCreateMode === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
            Search Event
          </h1>

          <form
            className="p-3 row"
            onSubmit={(e) => {
              handleSearchSubmit(e);
            }}
            onReset={(e) => {
              handleSearchFormReset(e);
            }}
          >
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="Title"
                name="title"
                id="title"
                handleChange={(e) => handleSearchChange(e)}
                value={Filter?.title}
              />
            </div>

            <div className="col-md-4">
              <DateInput
                name="start"
                id="start"
                handleChange={(e) => {
                  handleSearchChange(e, "startDateTime");
                }}
                placeholder="Select Date"
                showTimeSelect={true}
                label={"Start Date & Time"}
                value={Filter?.startDateTime}
                isClearable={Filter?.startDateTime}
              // minTime={
              //   isSameDay(
              //     Filter?.startDateTime
              //       ? new Date(Filter?.startDateTime)
              //       : new Date(),
              //     new Date()
              //   )
              //     ? new Date()
              //     : new Date(new Date().setHours(0, 0, 0, 0))
              // }
              // maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
              // minDate={new Date()}
              // maxDate={Filter?.endDateTime}
              />
            </div>

            <div className="col-md-4">
              <DateInput
                name="end"
                id="end"
                value={Filter?.endDateTime}
                handleChange={(e) => {
                  handleSearchChange(e, "endDateTime");
                }}
                placeholder="Select Date"
                showTimeSelect={true}
                label={"End Date & Time"}
                isClearable={Filter?.endDateTime}
                minDate={Filter?.startDateTime}
                minTime={
                  !isSameDay(
                    Filter?.startDateTime,
                    Filter?.startDateTime === ""
                      ? Filter?.startDateTime
                      : Filter?.endDateTime,
                  )
                    ? new Date(new Date().setHours(0, 0, 0, 0))
                    : Filter?.startDateTime
                }
                maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
              />
            </div>

            <div className="col-md-4">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => handleSearchChange(e)}
                selectedValue={Filter?.status}
                value={Filter?.status}
              />
            </div>

            <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
              <Button status="secondary" label="Search" type="submit" />
              <Button status="reset" label="Reset" type="reset" />
            </div>
          </form>
        </div>
      )}
      {(isEditMode || isCreateMode) && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            {isEditMode ? "Edit" : "Create"} Event
          </h1>

          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
            className="p-3 row mb-4"
          >
            <div className="col-md-12 mb-2">
              <RadioInput
                name="eventType"
                id="eventType"
                label="Event"
                options={eventType}
                selectedValue={eventForm?.eventType}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
                disabled={isEditMode}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                name="title"
                id="title"
                label="Title"
                placeholder="Title"
                handleChange={(e) => {
                  handleChange(e);
                }}
                value={eventForm?.title}
                required
                maxLength={150}
                errorMessage={errorMessage}
              />
            </div>

            <div className="col-md-4">
              <DateInput
                name="start"
                id="start"
                handleChange={(e) => {
                  handleChange(e, "start");
                }}
                placeholder="Select Date"
                showTimeSelect={true}
                label={"Start Date & Time"}
                value={eventForm?.start}
                isClearable={eventForm?.start}
                errorMessage={errorMessage}
                required
                minDate={new Date()}
                // minTime={
                //   !isSameDay(
                //     eventForm?.start !== "" ? eventForm?.start : new Date(),
                //     new Date()
                //   )
                //     ? new Date(new Date().setHours(0, 0, 0, 0))
                //     : eventForm?.start !== ""
                //     ? eventForm?.start
                //     : new Date()
                // }
                // minTime={new Date()}
                minTime={
                  isSameDay(eventForm?.start || new Date(), new Date())
                    ? new Date() // restrict to current time if today
                    : new Date(new Date().setHours(0, 0, 0, 0)) // allow from 00:00 for future dates
                }
                maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
              />
            </div>
            <div className="col-md-4">
              <DateInput
                name="end"
                id="end"
                value={eventForm?.end}
                handleChange={(e) => {
                  handleChange(e, "end");
                }}
                placeholder="Select Date"
                showTimeSelect={true}
                label={"End Date & Time"}
                isClearable={eventForm?.end}
                errorMessage={errorMessage}
                minDate={eventForm?.start}
                minTime={
                  !isSameDay(
                    eventForm?.start,
                    eventForm?.end === "" ? eventForm?.start : eventForm?.end,
                  )
                    ? new Date(new Date().setHours(0, 0, 0, 0))
                    : new Date(new Date(eventForm?.start).getTime() + 1 * 60000)
                }
                maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
                required
              />
            </div>

            {eventForm?.eventType === "recurrence" && (
              <div className="col-md-4">
                <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
                  All Day
                </label>
                <ToggleSwitch
                  name={`allDay`}
                  id={`allDay`}
                  checked={eventForm.allDay}
                  value={eventForm.allDay === 1 ? true : false}
                  handleClick={(e) => handleAllDay(e)}
                />
              </div>
            )}

            {eventForm?.eventType === "recurrence" &&
              eventForm?.allDay === 0 && (
                <>
                  <div className="col-md-4">
                    <SelectInput
                      options={numberSet}
                      name="repeatEvery"
                      id="repeatEvery"
                      label="Repeat Every"
                      handleChange={(e) => {
                        handleSelectBoxChanges(e, "repeatEvery");
                      }}
                      value={eventForm?.repeatEvery}
                    />
                  </div>

                  <div className="col-md-4">
                    <SelectInput
                      options={periodSet}
                      name="period"
                      id="period"
                      label="Period"
                      handleChange={(e) => {
                        handleSelectBoxChanges(e, "period");
                      }}
                      value={eventForm?.period}
                    />
                  </div>

                  {eventForm?.period === "week" && (
                    <div className="col-md-4 mt-4   ">
                      <MultiSelectDropdown
                        options={daySet}
                        displayValue="label"
                        handleChange={(e) =>
                          handleWeekDayChanges(e, "weekDaySelected")
                        }
                        placeholder="Choose Day(s)"
                        required
                        label="Choose Day(s)"
                        errorMessage={errorMessage}
                        selectedValue={daySet?.filter((option) =>
                          eventForm?.weekDaySelected.includes(option.value),
                        )}
                        sortType="custom"
                      />
                    </div>
                  )}

                  {eventForm?.period === "month" && (
                    <>
                      <div className="col-md-4 mt-4">
                        <SelectInput
                          options={monthFrequencySet}
                          name="monthFrequency"
                          id="monthFrequency"
                          label="Month Frequency"
                          handleChange={(e) => {
                            handleSelectBoxChanges(e, "monthFrequency");
                          }}
                          value={eventForm?.monthFrequency}
                        />
                      </div>

                      <div className="col-md-4 mt-4   ">
                        <MultiSelectDropdown
                          options={daySet}
                          displayValue="label"
                          handleChange={(e) =>
                            handleMonthDayChanges(e, "monthDaySelected")
                          }
                          placeholder="Choose Day(s)"
                          // required
                          label="Choose Day(s)"
                          errorMessage={errorMessage}
                          selectedValue={daySet?.filter((option) =>
                            eventForm?.monthDaySelected.includes(option.value),
                          )}
                          sortType="custom"
                        />
                      </div>
                    </>
                  )}
                </>
              )}

            <div className="col-md-4 mt-0">
              <RadioInput
                name="location"
                id="location"
                label="Mode of Event"
                options={locationType}
                selectedValue={eventForm?.location}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
              />
            </div>


            {(eventForm?.location === "virtual" ||
              eventForm?.location === "hybrid") && (
                <div className="col-md-4 mt-4">
                  <TextInput
                    name="url"
                    id="url"
                    label="URL"
                    value={eventForm?.url}
                    placeholder="Enter your Link"
                    handleChange={(e) => handleChange(e)}
                    required
                    errorMessage={errorMessage}
                  />

                </div>
              )}
            {(eventForm?.location === "virtual" ||
              eventForm?.location === "hybrid") && (
                <div className="col-md-4 mt-4">
                  <>
                    {/* <TextInput
                    name="url"
                    id="url"
                    label="URL"
                    value={eventForm?.url}
                    placeholder="Enter your Link"
                    handleChange={(e) => handleChange(e)}
                    required
                    errorMessage={errorMessage}
                  /> */}
                    <TextInput
                      name="passcode"
                      id="passcode"
                      label="Passcode"
                      value={eventForm?.passcode}
                      placeholder="Enter your Passcode"
                      handleChange={(e) => handleChange(e)}
                      errorMessage={errorMessage}
                    />
                  </>
                </div>
              )}
            {/* Physical or Both -> Show Address */}
            {(eventForm?.location === "physical" ||
              eventForm?.location === "hybrid") && (
                <div className="col-md-4 mt-0">
                  <TextAreaInput
                    label="Address"
                    name="address"
                    id="address"
                    value={eventForm?.address}
                    placeholder="Enter meeting location"
                    handleChange={(e) => handleChange(e)}
                    errorMessage={errorMessage}
                    required
                    maxLength={250}
                  />
                </div>
              )}
            <div className="row">
              <div className="col-md-12">
                <TextAreaInput
                  name="description"
                  id="description"
                  label="Description"
                  placeholder="Description"
                  value={eventForm?.description}
                  handleChange={(e) => {
                    handleChange(e);
                  }}
                  errorMessage={errorMessage}
                  maxLength={2500}
                />
              </div>
            </div>

            <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
              <Button
                label={isEditMode ? "Update" : "Add"}
                status="primary"
                type="submit"
                disabled={isPending}
              />
              <Button
                label="Reset"
                status="reset"
                type="reset"
                onClick={() => {
                  handleReset();
                }}
              />
            </div>
          </form>
        </div>
      )}
      {isEditMode === false && isCreateMode === false && (
        <>
          <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
            <h1 className="m-0 search-header-color p-3 ">Single Events List</h1>
            <Table
              columns={columns}
              data={getEventListResponse?.data?.events}
              pagination
              onChangeRowsPerPage={handleRowPerPage}
              onChangePage={handlePageChange}
              totalRowCount={totalCount || 0}
              currentPage={pageNo}
              paginationPerPage={rowCountPerPage}
            />
          </div>
          <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
            <h1 className="m-0 search-header-color p-3 ">
              Recurrence Events List
            </h1>

            <CollapsibleTable
              columns={recurrenceTableColumn}
              data={getRecurrenceEventListResponse?.data?.events}
              pagination
              onChangeRowsPerPage={handleRcurrenceRowPerPage}
              onChangePage={handleRecurrencePageChange}
              totalRowCount={recurrenceTotalCount || 0}
              currentPage={recurrencePageNo}
              paginationPerPage={recurrencerowCountPerPage}
              onRowClick={handleRowClick}
              nestedColumns={ChildrenColumn}
              expandableRowExpanded={true}
              expandedRows={expandedRows}
            />
          </div>
        </>
      )}
    </>
  );
}
export default CommitteeEventPage;
